<template>
  <div class="agent-profile-container" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top: ${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <!-- Agent Profile Hostess Profile -->
          <span class="tit-left">{{ $t(pageTitleKey) }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="page-content" :style="`margin-top: ${topBarHeight + 46}px`">
      <!-- Contact Card Section -->
      <div class="contact-card">
        <div class="user-info-row">
          <img v-if="selfContact.avatar" class="avatar-img" :src="selfContact.avatar | imgPath" alt="" />
          <div v-else class="avatar-placeholder"></div>
          <div class="user-detail">
            <div class="user-name">
              <span class="name-text">{{ selfContact.nickname }}</span>
              <span class="flag">
                <img :src="selfContact.locationFlagRound | imgPath" alt="" />
              </span>
            </div>
            <div class="user-id" @click="handleCopy(selfContact.presentId, $t('lang.BaseModule.k070'))">
              <span class="user-id-text">
                <span class="user-id-text-label">{{ $t('lang.AgentProfile.k002') }}</span>
                <span class="user-id-text-value">{{ selfContact.presentId }}</span>
              </span>
              <span class="copy-icon"></span>
            </div>
          </div>
        </div>

        <div class="contact-rows">
          <div class="contact-row" @click="handleEditContact">
            <span class="contact-label">{{ $t('lang.BaseModule.k064') }}</span>
            <div class="contact-action">
              <span class="id-text">{{ selfContact.whatsapp || $t('lang.BaseModule.k003') }}</span>
              <span class="arrow-right"></span>
            </div>
          </div>

          <div class="contact-row" @click="handleEditContact">
            <span class="contact-label">{{ $t('lang.BaseModule.k058') }}</span>
            <div class="contact-action">
              <span class="id-text">{{ selfContact.telegram || $t('lang.BaseModule.k003') }}</span>
              <span class="arrow-right"></span>
            </div>
          </div>
        </div>

        <div class="contact-tips">{{ $t(contactTipsKey) }}</div>
      </div>

      <!-- Bind Upline agent My Agent -->
      <div v-if="showUplineBindForm || uplineBound" class="panel-section bind-upline-section">
        <div class="panel-title">{{ $t(uplineSectionTitleKey) }}</div>
        <div class="bind-upline-body">
          <template v-if="showUplineBindForm">
            <div class="bind-upline-row">
              <input v-model.trim="uplineInviteCode" class="bind-input" type="text" :placeholder="$t('lang.Invite.k086')" />
              <div class="bind-btn" :class="{ 'is-disabled': bindSubmitting }" @click="handleBindUpline">{{ $t('lang.BaseModule.k009') }}</div>
            </div>
            <div class="bind-countdown">
              <span class="bind-countdown-label">{{ $t('lang.Invite.k067') }}</span>
              <span class="bind-countdown-time" :class="{ 'is-urgent': uplineBindCountdownUrgent }">{{ uplineBindCountdownText }}</span>
            </div>
          </template>
          <div v-if="uplineBound" class="bound-upline-card">
            <img v-if="boundUplineAgent.avatar" class="bound-avatar" :src="boundUplineAgent.avatar | imgPath" alt="" />
            <div v-else class="bound-avatar bound-avatar-placeholder"></div>
            <div class="bound-info">
              <div class="bound-name-row">
                <span class="bound-name">{{ boundUplineAgent.nickname }}</span>
                <img class="bound-flag" :src="boundUplineAgent.locationFlagRound | imgPath" alt="" />
              </div>
              <div class="bound-id-row" @click="handleCopy(boundUplineAgent.presentId, $t('lang.BaseModule.k070'))">
                <span>{{ $t('lang.AgentProfile.k002') }} {{ boundUplineAgent.presentId }}</span>
                <img class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp" alt="" />
              </div>
            </div>
            <div class="bound-info-card-btn" @click="handleViewProfile(boundUplineAgent)">
              <img src="@/assets/packageAssets/views/P2_Page/Invite/default/info.webp" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- My Team -->
      <div v-if="isAgentScene" class="panel-section my-team-section">
        <div class="panel-title">{{ $t('lang.AgentProfile.k010') }}</div>
        <div class="team-stats">
          <div class="team-stat-card">
            <div class="team-stat-value">{{ teamStats.hostCount }}</div>
            <div class="team-stat-label">{{ $t('lang.Invite.k008') }}</div>
          </div>
          <div class="team-stat-card">
            <div class="team-stat-value">{{ teamStats.subAgentCount }}</div>
            <div class="team-stat-label">{{ $t('lang.AgentProfile.k011') }}</div>
          </div>
        </div>
      </div>

      <!-- Member list -->
      <div v-if="isAgentScene" class="panel-section member-list-section">
        <div class="member-switch-tab">
          <div class="member-switch-inner">
            <div class="member-tab" :class="{ 'active-tab': memberTabIndex === 0 }" @click="handleMemberTab(0)">{{ $t('lang.BaseModule.k028') }}</div>
            <div class="member-tab" :class="{ 'active-tab': memberTabIndex === 1 }" @click="handleMemberTab(1)">{{ $t('lang.Invite.k057') }}</div>
          </div>
        </div>

        <div class="member-search">
          <input v-model.trim="searchMemberId" :placeholder="memberSearchPlaceholder" />
          <div class="search-divider"></div>
          <div class="search-btn" @click="handleMemberSearch">{{ $t('lang.BaseModule.k052') }}</div>
        </div>

        <div class="hostes-list">
          <div class="hostes-card" v-for="(item, index) in displayMemberList" :key="`${memberTabIndex}-${index}`">
            <div class="hostes-card-main" :class="{ 'has-footer': item.inviteCount != null }">
              <van-image v-if="item.avatar" class="hostes-avatar-img" :src="item.avatar | imgPath" fit="cover" round lazy-load />
              <div v-else class="hostes-avatar-placeholder"></div>
              <div class="hostes-info">
                <div class="host-name-row">
                  <span class="host-name">{{ item.nickname }}</span>
                  <img class="country-icon" :src="item.locationFlagRound | imgPath" alt="" />
                </div>
                <div class="host-id-row" @click="handleCopy(item.presentId, $t('lang.BaseModule.k070'))">
                  <span>{{ $t('lang.AgentProfile.k002') }} {{ item.presentId }}</span>
                  <img class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp" alt="" />
                </div>
              </div>
              <div class="info-card-btn" @click="handleViewProfile(item)">
                <img src="@/assets/packageAssets/views/P2_Page/Invite/default/info.webp" alt="" />
              </div>
            </div>
            <div v-if="item.inviteCount != null" class="hostes-card-footer">
              <MyPLabel :str="$t('lang.AgentProfile.k012')" :numsOption="[{ value: item.inviteCount || '0' }]" />
            </div>
          </div>

          <div v-if="isAgentScene && loading" class="is-loading">
            <van-loading size="24px" />
          </div>
          <div v-if="isAgentScene && memberSearchNoResult && !isIniting" class="no-more">{{ $t('lang.AgentProfile.k021') }}</div>
          <div v-if="isAgentScene && finished && !memberSearchNoResult" class="no-more">{{ $t('lang.AgentProfile.k020') }}</div>

          <div :style="{ height: `${bottomBarHeight + 82}px` }"></div>
        </div>
        <div class="list-height-spacer" style="height: 350px"></div>
      </div>
    </div>

    <!-- View Contact Popup -->
    <van-popup v-model="showViewContact" round :style="{ background: 'transparent' }" :close-on-click-overlay="true">
      <div class="view-contact-container">
        <div class="view-contact-popup">
          <div class="view-contact-header">
            <div class="view-avatar-wrap">
              <img v-if="viewContact.avatar" class="view-avatar-img" :src="viewContact.avatar | imgPath" alt="" />
              <div v-else class="view-avatar-placeholder"></div>
            </div>
            <div class="view-user-name">
              <span class="name-text">{{ viewContact.nickname }}</span>
              <img class="flag" :src="viewContact.locationFlagRound | imgPath" alt="" />
            </div>
          </div>

          <div class="view-contact-list">
            <div class="view-contact-row">
              <span class="view-label">{{ $t('lang.BaseModule.k064') }}</span>
              <div class="view-value">
                <span :class="{ 'is-empty': !viewContact.whatsapp }">{{ viewContact.whatsapp || $t('lang.Invite.k054') }}</span>
                <img
                  class="copy-icon"
                  :class="{ 'is-disabled': !viewContact.whatsapp }"
                  src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp"
                  alt=""
                  @click="viewContact.whatsapp && handleCopy(viewContact.whatsapp, $t('lang.BaseModule.k070'))"
                />
              </div>
            </div>

            <div class="view-contact-row">
              <span class="view-label">{{ $t('lang.BaseModule.k058') }}</span>
              <div class="view-value">
                <span :class="{ 'is-empty': !viewContact.telegram }">{{ viewContact.telegram || $t('lang.Invite.k054') }}</span>
                <img
                  class="copy-icon"
                  :class="{ 'is-disabled': !viewContact.telegram }"
                  src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp"
                  alt=""
                  @click="viewContact.telegram && handleCopy(viewContact.telegram, $t('lang.BaseModule.k070'))"
                />
              </div>
            </div>
          </div>

          <div class="popup-btn" :class="shareContactBtnClass" @click="handleShareContact">{{ $t(shareContactBtnTextKey) }}</div>
        </div>
      </div>
    </van-popup>

    <!-- Edit Contact Popup -->
    <van-popup v-model="showEditContact" round :style="{ background: 'transparent' }" :close-on-click-overlay="true">
      <div class="edit-contact-container">
        <div class="edit-contact-popup">
          <div class="popup-title">{{ $t('lang.AgentProfile.k003') }}</div>

          <div class="edit-contact-list">
            <div class="edit-contact-row">
              <span class="field-label">{{ $t('lang.BaseModule.k064') }}:</span>
              <input class="field-input" v-model.trim="editWhatsApp" maxlength="50" placeholder="" />
            </div>

            <div class="edit-contact-row">
              <span class="field-label">{{ $t('lang.BaseModule.k058') }}:</span>
              <input class="field-input" v-model.trim="editTelegram" maxlength="50" placeholder="" />
            </div>
          </div>

          <div class="popup-btn ok" :class="{ 'is-disabled': !isContactFilled }" @click="handleConfirmContact">{{ $t('lang.BaseModule.k073') }}</div>
          <div class="popup-btn cancel" @click="showEditContact = false">{{ $t('lang.BaseModule.k067') }}</div>
        </div>
      </div>
    </van-popup>

    <BindAgentMessageDialog
      mode="confirm"
      :show="showBindMessageDialog"
      :nickname="bindConfirmNickname"
      @confirm="handleBindMessageConfirm"
      @cancel="handleBindMessageCancel"
      @close="handleBindMessageCancel"
    />
  </div>
</template>

<script>
import { getAllContactInfoApi, updateContactInfoApi, getContactInfoApi, sendContactInfoApi } from '@/api/invite.js'
import { checkInvitedAgentBeforeBind, submitAgentBind } from '@/views/P2_Page/Invite/utils/agent-bind.js'
import { remainSec, fmtText, isUrgent, hasUpper, mapUpper } from '@/views/P2_Page/Invite/utils/bind-countdown.js'
import { pageCssVars } from './z-style-cfg.js'

import BindAgentMessageDialog from '@/views/P2_Page/Invite/components/BindAgentMessageDialog.vue'

export default {
  name: 'AgentProfile',
  mixins: [pageCssVars],
  components: {
    BindAgentMessageDialog,
  },
  data() {
    return {
      // 自己
      selfContact: {
        avatar: '',
        nickname: '',
        presentId: '',
        telegram: '',
        uid: 0,
        whatsapp: '',
      },
      memberList: [],
      listQuery: { offset: 0, limit: 10 },
      isIniting: false,
      loading: false,
      finished: false,
      lockLoad: false,
      // 编辑
      showEditContact: false,
      submitting: false,
      editWhatsApp: '',
      editTelegram: '',
      // 展示
      showViewContact: false,
      viewContactMember: null,
      sendContactSubmitting: false,
      viewContact: {
        avatar: '',
        nickname: '',
        uid: 0,
        whatsapp: '',
        telegram: '',
        locationFlagRound: '',
      },
      // 绑定上级代理
      upperAgent: null,
      becomeSubAgentDeadTime: 0,
      uplineInviteCode: '',
      uplineBindRemainingSeconds: 0,
      uplineBindCountdownTimer: null,
      bindSubmitting: false,
      showBindMessageDialog: false,
      bindConfirmNickname: '',
      pendingBindCode: '',
      boundUplineAgent: {
        avatar: '',
        nickname: '',
        presentId: '',
        locationFlagRound: '',
        uid: 0,
        hasContact: false,
        canSendContact: false,
        type: '2',
      },
      teamStats: {
        hostCount: 0,
        subAgentCount: 0,
      },
      memberTabIndex: 0,
      searchMemberId: '',
      memberSearchNoResult: false,
    }
  },
  computed: {
    pageScene() {
      return String(this.$route.query.scene) === '1' ? '1' : '0'
    },
    isAgentScene() {
      return this.pageScene === '0'
    },
    isHostessScene() {
      return this.pageScene === '1'
    },
    pageTitleKey() {
      return this.isHostessScene ? 'lang.AgentProfile.k004' : 'lang.AgentProfile.k001'
    },
    contactTipsKey() {
      return this.isHostessScene ? 'lang.AgentProfile.k007' : 'lang.AgentProfile.k008'
    },
    uplineSectionTitleKey() {
      if (this.isHostessScene) {
        return 'lang.AgentProfile.k005'
      }
      return hasUpper(this.upperAgent) ? 'lang.AgentProfile.k015' : 'lang.AgentProfile.k009'
    },
    isContactFilled() {
      return this.editWhatsApp.length > 0 || this.editTelegram.length > 0
    },
    uplineBound() {
      return hasUpper(this.upperAgent)
    },
    showUplineBindForm() {
      return this.isAgentScene && !this.uplineBound && this.uplineBindRemainingSeconds > 0
    },
    showBindUplineSection() {
      return this.uplineBound || this.showUplineBindForm
    },
    uplineBindCountdownText() {
      return fmtText(this.uplineBindRemainingSeconds || 0)
    },
    uplineBindCountdownUrgent() {
      return isUrgent(this.uplineBindRemainingSeconds || 0)
    },
    memberSearchPlaceholder() {
      return this.memberTabIndex === 0 ? this.$t('lang.Invite.k055') : this.$t('lang.Invite.k056')
    },
    memberListType() {
      return this.memberTabIndex === 0 ? '1' : '2'
    },
    displayMemberList() {
      return this.memberList
    },
    selfHasContact() {
      return !!(this.selfContact.whatsapp || this.selfContact.telegram)
    },
    viewContactHasContact() {
      return !!(this.viewContact.whatsapp || this.viewContact.telegram)
    },
    canTriggerShareContact() {
      if (!this.viewContactMember) {
        return false
      }
      //
      else {
        return !!this.viewContactMember.canSendContact
      }
    },
    shareContactBtnClass() {
      if (!this.selfHasContact) {
        return 'can-not-share'
      }
      if (this.selfHasContact && !this.canTriggerShareContact) {
        return 'can-share'
      }
      if (this.selfHasContact && !this.viewContactHasContact) {
        return 'highlight-share'
      }
    },
    shareContactBtnTextKey() {
      const gender = this.viewContactMember?.gender ?? this.viewContact?.gender
      if (Number(gender) === 2) {
        return 'lang.AgentProfile.k013'
      }
      if (Number(gender) === 1) {
        return 'lang.AgentProfile.k016'
      }
    },
  },
  methods: {
    syncContactBindInfo(resData) {
      this.becomeSubAgentDeadTime = (resData && resData.becomeSubAgentDeadTime) || 0
      this.upperAgent = (resData && resData.upperAgent) || null
      this.teamStats = {
        hostCount: (resData && resData.hostCount) ?? 0,
        subAgentCount: (resData && resData.subAgentCount) ?? 0,
      }
      this.boundUplineAgent = mapUpper(this.upperAgent) || {
        avatar: '',
        nickname: '',
        presentId: '',
        locationFlagRound: '',
        uid: 0,
        hasContact: false,
        canSendContact: false,
        type: '2',
      }
      this.updateUplineBindCountdown()
      this.startUplineBindCountdown()
    },
    buildContactListParams() {
      return {
        uid: this.getUid(),
        scene: this.pageScene,
        type: this.memberListType,
        offset: this.listQuery.offset,
        limit: this.listQuery.limit,
      }
    },
    mapContactInfoToMember(resData) {
      if (!resData || resData.error) return null
      return {
        avatar: resData.avatar || '',
        nickname: resData.nickname || '',
        presentId: resData.presentId || '',
        locationFlagRound: resData.locationFlagRound || '',
        uid: resData.uid || 0,
        inviteCount: resData.inviteCount,
        canSendContact: resData.canSendContact,
        gender: resData.gender,
        hasContact: !!(resData.whatsapp || resData.telegram),
      }
    },
    closeBindMessageDialog() {
      this.showBindMessageDialog = false
      this.bindConfirmNickname = ''
    },
    handleBindMessageConfirm() {
      this.showBindMessageDialog = false
      this.doSubmitAgentBind(this.pendingBindCode)
    },
    handleBindMessageCancel() {
      this.bindSubmitting = false
      this.pendingBindCode = ''
      this.closeBindMessageDialog()
    },
    doSubmitAgentBind(code) {
      const inviteCode = (code || '').trim()
      if (!inviteCode) {
        this.bindSubmitting = false
        return Promise.resolve()
      }
      // 实际绑定api接口
      submitAgentBind(inviteCode)
        .then((resData) => {
          if (resData) {
            // 绑定成功
            if (!resData.error) {
              const tempTip = this.replaceOneText(this.$t('lang.Invite.k094'), '{n0}', resData.nickName || '') || this.$t('lang.BaseModule.k056')
              this.$client.showToast(tempTip)
              this.fetchContactInfo()
            }
            // 绑定失败
            else {
              this.$client.showToast(resData.error.description || this.$t('lang.AgentProfile.k019'))
            }
          }
        })
        .catch(() => {
          this.$client.showToast(this.$t('lang.AgentProfile.k019'))
        })
        .finally(() => {
          this.uplineInviteCode = ''
          this.pendingBindCode = ''
          this.bindSubmitting = false
        })
    },
    async fetchContactInfo() {
      this.listQuery.offset = 0
      this.finished = false
      this.memberSearchNoResult = false
      this.memberList = []
      this.isIniting = true

      try {
        const resData = await getAllContactInfoApi(this.buildContactListParams())
        if (resData && !resData.error) {
          this.selfContact = resData.selfContact || this.selfContact
          const list = resData.memList || []
          this.memberList = list
          this.listQuery.offset = list.length
          this.finished = list.length < this.listQuery.limit
          this.syncContactBindInfo(resData)
        }
      } catch (e) {}

      this.isIniting = false
    },
    async loadMore() {
      if (!this.isAgentScene || this.loading || this.finished || this.isIniting) return
      this.loading = true
      try {
        const resData = await getAllContactInfoApi(this.buildContactListParams())
        if (resData && !resData.error) {
          const list = resData.memList || []
          this.memberList = this.memberList.concat(list)
          this.listQuery.offset = this.memberList.length
          this.finished = list.length < this.listQuery.limit
        }
      } catch (e) {}
      this.loading = false
      this.lockLoad = false
    },
    onScroll(event) {
      if (!this.isAgentScene) return
      const clientH = document.documentElement.clientHeight
      const scrollH = document.body.scrollHeight
      const scrollT = event.target.scrollTop
      const distance = 5
      if (scrollT + clientH >= scrollH - distance) {
        if (!this.lockLoad) {
          this.lockLoad = true
          setTimeout(() => {
            this.loadMore()
          }, 100)
        }
      }
    },
    handleBindUpline() {
      if (!this.isAgentScene) return
      const code = (this.uplineInviteCode || '').trim()
      if (!code || this.bindSubmitting) return

      this.bindSubmitting = true
      this.pendingBindCode = code
      checkInvitedAgentBeforeBind(code)
        .then(({ needConfirm, agentInfo }) => {
          if (needConfirm) {
            this.bindConfirmNickname = (agentInfo && agentInfo.nickname) || ''
            this.showBindMessageDialog = true
            return
          }
          return this.doSubmitAgentBind(code)
        })
        .catch(() => {
          this.bindSubmitting = false
          this.pendingBindCode = ''
        })
    },
    updateUplineBindCountdown() {
      this.uplineBindRemainingSeconds = remainSec(this.becomeSubAgentDeadTime)
    },
    startUplineBindCountdown() {
      this.stopUplineBindCountdown()
      this.updateUplineBindCountdown()
      if (!this.showUplineBindForm) return

      this.uplineBindCountdownTimer = setInterval(() => {
        if (this.uplineBindRemainingSeconds <= 0) {
          this.stopUplineBindCountdown()
          return
        }
        this.uplineBindRemainingSeconds--
      }, 1000)
    },
    stopUplineBindCountdown() {
      if (this.uplineBindCountdownTimer) {
        clearInterval(this.uplineBindCountdownTimer)
        this.uplineBindCountdownTimer = null
      }
    },
    handleMemberTab(index) {
      if (this.memberTabIndex === index) return
      this.memberTabIndex = index
      this.searchMemberId = ''
      this.memberSearchNoResult = false
      this.fetchContactInfo()
    },
    async handleMemberSearch() {
      this.searchMemberId = (this.searchMemberId || '').trim()
      if (!this.searchMemberId) {
        this.memberSearchNoResult = false
        this.fetchContactInfo()
        return
      }

      this.listQuery.offset = 0
      this.finished = false
      this.memberSearchNoResult = false
      this.memberList = []
      this.isIniting = true

      try {
        const resData = await getContactInfoApi({
          toUid: 0,
          scene: this.pageScene,
          presentId: this.searchMemberId,
        })
        const member = this.mapContactInfoToMember(resData)
        if (member) {
          this.memberList = [member]
        } else {
          this.memberList = []
          this.memberSearchNoResult = true
        }
      } catch (e) {
        this.memberList = []
        this.memberSearchNoResult = true
      }

      this.isIniting = false
    },
    handleEditContact() {
      this.editWhatsApp = this.selfContact.whatsapp || ''
      this.editTelegram = this.selfContact.telegram || ''
      this.showEditContact = true
    },
    async handleConfirmContact() {
      if (!this.isContactFilled) return
      if (this.submitting) return
      this.submitting = true
      try {
        const resData = await updateContactInfoApi({
          telegram: this.editTelegram,
          whatsapp: this.editWhatsApp,
        })

        if (resData && !resData.error) {
          this.selfContact.whatsapp = this.editWhatsApp
          this.selfContact.telegram = this.editTelegram
          this.showEditContact = false
          this.$client.showToast(this.$t('lang.BaseModule.k056'))
          this.fetchContactInfo()
        }
      } catch (e) {
        this.submitting = false
      } finally {
        this.submitting = false
      }
    },
    async handleViewProfile(item) {
      try {
        const resData = await getContactInfoApi({
          toUid: item.uid,
          scene: this.pageScene,
        })
        if (resData && !resData.error) {
          this.viewContactMember = {
            ...item,
            gender: resData.gender ?? item.gender,
          }
          this.viewContact = resData
          this.showViewContact = true
        }
      } catch (e) {}
    },
    async handleShareContact() {
      // 自己未填联系方式
      if (!this.selfHasContact) {
        this.$client.showToast(this.$t('lang.AgentProfile.k006'))
        return
      }
      // 24小时内已经发过1次
      if (!this.canTriggerShareContact) {
        try {
          const nextTime = this.handleMoment(this.viewContactMember.nextSendTime, 'YYYY-MM-DD HH:mm:ss')
          const tips = this.replaceOneText(this.$t('lang.AgentProfile.k018'), '{n0}', `${nextTime}`)
          this.$client.showToast(tips)
        } catch {
          console.log('try catch error:', 'handleShareContact')
        }
        return
      }

      if (this.sendContactSubmitting) {
        return
      }
      this.sendContactSubmitting = true
      try {
        const resData = await sendContactInfoApi({
          scene: this.pageScene,
          toUid: this.viewContactMember.uid,
          type: this.viewContactMember.type ? this.viewContactMember.type : this.memberListType,
        })
        if (resData && !resData.error) {
          this.$client.showToast(this.$t('lang.AgentProfile.k014'))
          this.showViewContact = false
          await this.fetchContactInfo()
        }
      } catch (e) {
        console.log('try catch error:', 'sendContactInfoApi')
      } finally {
        this.sendContactSubmitting = false
      }
    },
  },
  watch: {
    '$route.query.scene'() {
      this.stopUplineBindCountdown()
      this.fetchContactInfo()
    },
  },
  created() {
    this.fetchContactInfo()
  },
  mounted() {
    document.body.scrollTo({ top: 0 })
    document.body.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.onScroll)
    this.stopUplineBindCountdown()
  },
}
</script>

<style lang="scss" scoped>
.agent-profile-container {
  width: 100%;
  background-color: #f7f7f7;

  // --- .custom-nav-block > van-nav-bar（.left-nav / .tit-left）---
  .custom-nav-block {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background-color: #ffffff;
    .left-nav {
      width: 20px;
      height: 20px;
      object-fit: contain;
    }
  }

  // --- .page-content ---
  .page-content {
    padding: 0 16px;

    // --- .contact-card：头像区 / WhatsApp / Telegram / 提示 ---
    .contact-card {
      margin: 0 -16px 8px;
      padding: 16px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      gap: 12px;

      .user-info-row {
        display: flex;
        align-items: center;
        gap: 8px;

        .avatar-placeholder,
        .avatar-img {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background-color: #eaeaea;
          flex-shrink: 0;
          object-fit: cover;
        }

        .user-detail {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .user-name {
            margin-bottom: 0;
            gap: 4px;

            .name-text {
              max-width: 245px;
              font-size: var(--fs-20);
              line-height: 28px;
            }

            .flag {
              width: 16px;
              height: 16px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .user-id {
            gap: 2px;
            font-size: 12px;
            line-height: 16px;
            color: #b2b2b2;

            .user-id-text-value {
              padding: 0;
            }

            .copy-icon {
              margin: 0;
              background: url('~@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp') left top / 100% auto no-repeat;
            }
          }
        }
      }

      .contact-rows {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
      }

      .contact-row {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 16px 12px;
        border-radius: 8px;
        background: #f9f9f9;

        .contact-label {
          flex: 1;
          min-width: 0;
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-400);
          line-height: var(--lh-title-20);
          color: #666666;
        }

        .contact-action {
          display: flex;
          align-items: center;
          gap: 2px;
          flex-shrink: 0;

          .id-text {
            font-family: var(--string-font);
            font-size: var(--fs-14);
            font-weight: var(--fw-400);
            line-height: var(--lh-title-20);
            color: #333333;
            white-space: nowrap;
          }

          .arrow-right {
            width: 16px;
            height: 16px;
            transform: rotateZ(90deg);
            background: url('~@/assets/packageAssets/common/arrow08.webp') left top / 100% 100% no-repeat;
          }
        }
      }

      .contact-tips {
        font-family: var(--string-font);
        font-size: 12px;
        font-weight: var(--fw-400);
        line-height: 16px;
        color: #b2b2b2;
      }
    }

    .panel-section {
      margin: 0 -16px 8px;
      padding: 12px 16px;
      background: #ffffff;
    }

    .panel-title {
      padding: 4px 0;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);
      color: #333333;
    }

    .bind-upline-body {
      padding: 12px 0;
    }

    .bind-upline-row {
      display: flex;
      align-items: center;
      gap: 6px;
      height: 52px;
    }

    .bind-input {
      flex: 1;
      min-width: 0;
      height: 52px;
      padding: 16px 12px;
      border: none;
      border-radius: 12px;
      background: #f9f9f9;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);
      color: #333333;
      box-sizing: border-box;
      outline: none;

      &::placeholder {
        color: #cccccc;
      }
    }

    .bind-btn {
      flex-shrink: 0;
      height: 52px;
      padding: 6px 24px;
      border-radius: 12px;
      background: #f8e5bd;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);
      color: #925e0d;
      white-space: nowrap;
      cursor: pointer;
    }

    .bind-btn.is-disabled {
      opacity: 0.6;
      pointer-events: none;
    }

    .bind-countdown {
      margin-top: 8px;
      padding: 0 4px;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);

      .bind-countdown-label {
        color: #cccccc;
      }

      .bind-countdown-time {
        margin-left: 4px;
        color: #333333;

        &.is-urgent {
          font-weight: var(--fw-600);
          font-variant-numeric: tabular-nums;
          color: #333333;
        }
      }
    }

    .bound-upline-card {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 16px 12px;
      border-radius: 12px;
      background: #f8e5bd;

      .bound-avatar,
      .bound-avatar-placeholder {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        flex-shrink: 0;
        object-fit: cover;
        background: #eaeaea;
      }

      .bound-info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .bound-name-row {
        display: flex;
        align-items: center;
        gap: 2px;

        .bound-name {
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-400);
          line-height: var(--lh-title-20);
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .bound-flag {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          flex-shrink: 0;
          object-fit: cover;
        }
      }

      .bound-id-row {
        display: flex;
        align-items: center;
        gap: 2px;
        font-family: var(--string-font);
        font-size: 12px;
        line-height: 16px;
        color: #925e0d;

        .copy-icon {
          width: 16px;
          height: 16px;
        }
      }

      .bound-info-card-btn {
        flex-shrink: 0;
        display: flex;
        padding: 4px 8px;
        justify-content: center;
        align-items: center;
        border-radius: 18px;
        background: #ffffff;
        cursor: pointer;

        img {
          width: 16px;
          height: 16px;
        }
      }
    }

    .team-stats {
      display: flex;
      gap: 8px;
      padding: 4px 0;
    }

    .team-stat-card {
      flex: 1;
      min-width: 0;
      min-height: 86px;
      padding: 12px 14px;
      border-radius: 12px;
      background: #f9f9f9;
      display: flex;
      flex-direction: column;
      gap: 8px;
      box-sizing: border-box;

      .team-stat-value {
        flex: 1;
        font-family: var(--number-font);
        font-style: italic;
        font-weight: var(--fw-500);
        font-size: 24px;
        line-height: 32px;
        color: #333333;
      }

      .team-stat-label {
        font-family: var(--string-font);
        font-size: var(--fs-12);
        font-weight: var(--fw-400);
        line-height: var(--lh-body-18);
        color: #666666;
      }
    }

    .member-list-section {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .member-switch-tab {
      margin: 0 auto;
      padding: 8px 12px;

      .member-switch-inner {
        display: flex;
        align-items: center;
        background: #eeeae4;
        border-radius: 36px;
      }

      .member-tab {
        min-width: 150px;
        padding: 10px 8px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-12);
        line-height: var(--lh-title-20);
        letter-spacing: -0.3px;
        color: #a9a092;
        text-align: center;
        white-space: nowrap;

        &.active-tab {
          border: 4px solid #eeeae4;
          border-radius: 36px;
          color: #ffffff;
          background: linear-gradient(180deg, #c6a175 0%, #86592e 100%);
        }
      }
    }

    .member-search {
      display: flex;
      align-items: center;
      width: 100%;
      background: #f6f6f5;
      border-radius: 8px;
      overflow: hidden;

      input {
        flex: 1;
        min-width: 0;
        height: 44px;
        padding: 0 12px;
        border: none;
        background: transparent;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-body-20);
        color: #333333;
        outline: none;

        &::placeholder {
          color: #cccccc;
        }
      }

      .search-divider {
        width: 1px;
        height: 16px;
        background: #d9d9d9;
        flex-shrink: 0;
      }

      .search-btn {
        padding: 12px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-body-20);
        color: #cccccc;
        white-space: nowrap;
        cursor: pointer;
      }
    }

    // --- .hostes-list > .hostes-card（新样式）---
    .hostes-list {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .hostes-card {
        border-radius: 12px;
        overflow: hidden;

        .hostes-card-main {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 20px 12px;
          background: #ffffff;
          border: 1px solid #f9f8f6;
          border-radius: 12px;

          &.has-footer {
            padding: 8px 12px;
            border-radius: 12px 12px 0 0;
            border-bottom: none;
          }
        }

        .hostes-avatar-img,
        .hostes-avatar-placeholder {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          flex-shrink: 0;
          object-fit: cover;
          background: #eaeaea;
        }

        .hostes-info {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .host-name-row {
          display: flex;
          align-items: center;
          gap: 2px;

          .host-name {
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-16);
            line-height: var(--lh-title-20);
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .country-icon {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            flex-shrink: 0;
            object-fit: cover;
          }
        }

        .host-id-row {
          display: flex;
          align-items: center;
          gap: 2px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-12);
          line-height: var(--lh-label-16);
          color: #b2b2b2;

          .copy-icon {
            width: 16px;
            height: 16px;
          }
        }

        .info-card-btn {
          flex-shrink: 0;
          display: flex;
          padding: 4px 8px;
          justify-content: center;
          align-items: center;
          border-radius: 18px;
          background: linear-gradient(273deg, #f6ddb9 0%, #f5efd9 100%), #fff;
          cursor: pointer;

          img {
            width: 16px;
            height: 16px;
          }
        }

        .hostes-card-footer {
          padding: 4px 12px;
          background: #f9f8f6;
          border-radius: 0 0 12px 12px;
          font-family: var(--string-font);
          font-size: 12px;
          line-height: 16px;
          color: #b2b2b2;
        }
      }
    }

    // 联系卡 .user-name、.user-id
    .user-name {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 4px;
      .name-text {
        max-width: 120px;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-600);
        line-height: var(--lh-title-20);
        color: #333333;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .flag {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        box-shadow: 0 0 1px 1px rgba(235, 235, 235, 0.9);
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .user-id {
      display: flex;
      align-items: center;
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);
      color: #b2b2b2;
      .user-id-text {
        .user-id-text-label {
          font-family: var(--string-font);
        }
        .user-id-text-value {
          font-family: var(--number-font);
          padding: 0 4px;
        }
      }
      .copy-icon {
        width: 16px;
        height: 16px;
        margin: 0 4px;
        background: url('~@/assets/packageAssets/views/P2_Page/AgentProfile/default/copy.webp') left top / 100% auto no-repeat;
      }
    }

    // 列表底部状态
    .is-loading {
      display: flex;
      justify-content: center;
      padding: 16px 0 8px;
    }
    .no-more {
      padding-top: 30px;
    }
  }
}

// van-popup：查看联系人
.view-contact-container {
  width: 343px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;

  .view-contact-popup {
    background: #fff;
    border-radius: 16px;
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;

    .view-contact-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;

      .view-avatar-wrap {
        .view-avatar-placeholder,
        .view-avatar-img {
          width: 68px;
          height: 68px;
          border-radius: 50%;
          background-color: #d0cdd8;
          object-fit: cover;
        }
      }

      .view-user-name {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2px;

        .name-text {
          max-width: 240px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-16);
          line-height: var(--lh-title-20);
          color: #333333;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .flag {
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
    }

    .view-contact-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 0;
      background: #f9f9f9;
      border-radius: 12px;
      box-sizing: border-box;
    }

    .view-contact-row {
      width: 100%;
      min-height: 52px;
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 16px 12px;
      box-sizing: border-box;

      .view-label {
        flex: 1;
        min-width: 0;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #666666;
      }

      .view-value {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        gap: 8px;

        span {
          max-width: 140px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-title-20);
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &.is-empty {
            color: #b2b2b2;
          }
        }

        .copy-icon {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          cursor: pointer;

          &.is-disabled {
            opacity: 0.4;
            cursor: default;
          }
        }
      }
    }

    .popup-btn {
      width: 100%;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 24px;
      border-radius: 12px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-title-20);
      white-space: nowrap;
      cursor: pointer;
      box-sizing: border-box;

      &.can-not-share {
        border: 1px solid #dbdbdb;
        background: #ffffff;
        color: #dbdbdb;
      }

      &.can-share {
        border: 1px solid #cdcdcd;
        background: #ffffff;
        color: #666666;
      }

      &.highlight-share {
        border: 1px solid #f8e5bd;
        background: #f8e5bd;
        color: #925e0d;
      }
    }
  }
}

// van-popup：编辑联系方式
.edit-contact-container {
  width: 343px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;

  .edit-contact-popup {
    background: #fff;
    border-radius: 16px;
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;

    .popup-title {
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);
      color: #333333;
      text-align: center;
    }

    .edit-contact-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 0;
      background: #f9f9f9;
      border-radius: 12px;
      box-sizing: border-box;
    }

    .edit-contact-row {
      width: 100%;
      min-height: 52px;
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 16px 12px;
      box-sizing: border-box;

      .field-label {
        flex-shrink: 0;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #666666;
        white-space: nowrap;
      }

      .field-input {
        flex: 1;
        min-width: 0;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #333333;
        text-align: start;
        background: transparent;
        border: none;
        outline: none;

        &::placeholder {
          color: #b2b2b2;
        }
      }
    }

    .popup-btn {
      width: 100%;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 24px;
      border-radius: 12px;
      font-family: var(--string-font);
      font-weight: var(--fw-500);
      font-size: var(--fs-16);
      line-height: var(--lh-title-20);
      white-space: nowrap;
      cursor: pointer;
      box-sizing: border-box;

      &.ok {
        background: #f8e5bd;
        color: #925e0d;
      }
      &.cancel {
        background: #ffffff;
        color: #666666;
        border: 1px solid #e6e5e7;
      }
      &.is-disabled {
        opacity: 0.4;
      }
    }
  }
}

// --- 头像高斯模糊（兼容旧 WebView：-webkit-filter 前缀；clip-path 限制模糊不溢出圆形容器）---
.bound-upline-card .bound-avatar,
.view-avatar-wrap .view-avatar-img,
.hostes-card ::v-deep .van-image__img {
  -webkit-filter: blur(3px);
  filter: blur(3px);
  -webkit-clip-path: circle(50%);
  clip-path: circle(50%);
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .agent-profile-container {
    .page-content {
      .contact-card {
        .contact-row {
          .contact-action {
            .arrow-right {
              transform: rotateZ(-90deg);
            }
          }
        }
      }
    }
  }
}
</style>
